import { createFileRoute } from "@tanstack/react-router";
import {
  bounceToAccountPath,
  haltForExternalNavigation,
} from "../lib/auth/app-origins";

/** Auth UI now lives on account-web — bounce old /forgot-password bookmarks. */
export const Route = createFileRoute("/forgot-password")({
  beforeLoad: () => {
    if (typeof window !== "undefined") {
      bounceToAccountPath("/forgot-password", window.location.search);
      haltForExternalNavigation();
    }
  },
  component: () => null,
});
